import React, { useState } from "react";
import { Field, formValueSelector, reduxForm, SubmissionError } from "redux-form";
import PropTypes from "prop-types";
import { Button, Form, withOverlay } from "@dpdgroupuk/mydpd-ui";
import { isEmpty, noop } from "lodash";
import { compose, withProps } from "recompose";
import { connect } from "react-redux";
import { trackProps, withTrack, withTrackProps } from "@dpdgroupuk/react-event-tracker";
import { useHistory } from "react-router";
import styles from "./ResetPasswordForm.module.scss";
import { ROUTE, FORM, ANALYTICS } from "../../../../constants";
import { StringUtil } from "../../../../utils";
import EmailSent from "../EmailSent/EmailSent";
import { withAppContext } from "../../../../Context";

const ResetPasswordForm = ({
  username,
  onCancel,
  onNext,
  pristine,
  submitting,
  handleSubmit,
  onResetEmailPassword,
  onInputChange
}) => {
  const history = useHistory();
  const [emailSent, setEmailSent] = useState(false);

  if (emailSent) {
    return /*#__PURE__*/React.createElement(EmailSent, null);
  }

  const onUsernameSubmitted = async formValues => {
    if (!StringUtil.isEmail(formValues?.username)) {
      return history.push({
        pathname: ROUTE.UPDATE_PASSWORD_PAGE,
        state: {
          username
        }
      });
    }

    await onResetEmailPassword(formValues.username);
    return setEmailSent(true);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.center
  }, /*#__PURE__*/React.createElement("h1", {
    className: styles.headerText
  }, "Forgotten Your Password?"), /*#__PURE__*/React.createElement("form", {
    className: styles.form,
    onSubmit: handleSubmit(onUsernameSubmitted),
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "username",
    id: "usernameField",
    type: "text",
    placeholder: "USERNAME",
    autoComplete: "username",
    label: "Username",
    component: Form.MaterialTextInput,
    maxLength: 100,
    onChange: onInputChange
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    id: "cancelBtn",
    onClick: onCancel,
    variant: "dark",
    className: styles.button
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    id: "submitBtn",
    type: "submit",
    variant: "primary",
    disabled: pristine || submitting || isEmpty(username),
    className: styles.button,
    onClick: onNext
  }, "Next"))), /*#__PURE__*/React.createElement("div", {
    className: styles.usernameText
  }, "Please enter your username"), /*#__PURE__*/React.createElement("div", {
    className: styles.divider
  }));
};

ResetPasswordForm.propTypes = {
  username: PropTypes.string,
  onCancel: PropTypes.func,
  onNext: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  onResetEmailPassword: PropTypes.func,
  onInputChange: PropTypes.func
};
export default compose(withOverlay, withAppContext, connect(state => {
  const selector = formValueSelector(FORM.RESET_PASSWORD_FORM);
  return {
    username: selector(state, "username")
  };
}, (dispatch, {
  app,
  overlay
}) => ({
  onResetEmailPassword: overlay.showWhile(async email => {
    try {
      await app.auth.resetEmailPassword(email);
    } catch (e) {
      throw new SubmissionError({
        _error: "Failed to reset email password"
      });
    }
  })
})), withProps(props => ({
  onCancel: () => props.history.push(ROUTE.LOGON_PAGE),
  onNext: noop
})), withTrack(trackProps(ANALYTICS.RESET_PASSWORD_PAGE)), withTrackProps({
  onCancel: ANALYTICS.RESET_PASSWORD_PAGE.ON_CANCEL,
  onNext: ANALYTICS.RESET_PASSWORD_PAGE.ON_NEXT,
  onInputChange: (e, prevValues, nextValues, name) => ANALYTICS.RESET_PASSWORD_PAGE.ON_INPUT_CHANGE[name]
}), reduxForm({
  form: FORM.RESET_PASSWORD_FORM
}))(ResetPasswordForm);